import { connect } from 'react-redux'
import App from './App'

import { currentUser } from '../auth/selectors'
import { isKioskMode } from '../kiosk/selectors'

const mapStateToProps = state => ({
  isKioskMode: isKioskMode(state),
  currentUser: currentUser(state),
})

export default connect(mapStateToProps)(App)
